var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftWhite = function SvgChevronLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 17a.999.999 0 0 0 .707-1.707l-3.305-3.305 3.18-3.293a1 1 0 0 0-1.44-1.39l-3.861 4a1 1 0 0 0 .012 1.402l4 4c.195.195.45.293.707.293Z",
    fill: "#fff"
  })));
};
export default SvgChevronLeftWhite;